<template>
  <section class="calendars">
    <div class="calendars__section">
      <p class="text-paper-700 mb-12 paragraph--xs">{{ t('common.form_calendar_section.one_step') }}</p>
      <p class="mb-12 calendars__title">{{ t('common.form_calendar_section.schedule_intro') }}</p>
      <p class="mb-40">{{ t('common.form_calendar_section.book_a_chat') }}</p>
      <p class="calendars__section-title mb-12">
        {{ t('common.form_calendar_section.select_your_region') }}
      </p>
      <div class="calendars__controls">
        <FormBaseRadioButton
          v-model="region"
          radio-group-id="calendars-region"
          :label="t('common.form_calendar_section.region_us')"
          value="us"
          size="s"
        />
        <FormBaseRadioButton
          v-model="region"
          radio-group-id="calendars-region"
          :label="t('common.form_calendar_section.region_dach_uk')"
          value="dachUk"
          size="s"
        />
        <FormBaseRadioButton
          v-model="region"
          radio-group-id="calendars-region"
          :label="t('common.form_calendar_section.region_all')"
          value="other"
          size="s"
        />
      </div>
    </div>
    <div class="calendars__section" id="form-calendar-section">
      <p class="calendars__section-title mb-12">
        {{ t('common.form_calendar_section.select_date_and_time') }}
      </p>
      <p class="paragraph--xs calendars__section-note mb-0">
        {{ t('common.form_calendar_section.note') }}
      </p>
      <HsIframeForm
        v-for="reg in Object.keys(hsCalendarLinks)"
        :key="reg"
        :src="hsCalendarLinks[reg as regions]"
        v-show="reg === region"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { Translation } from 'vue-i18n'
type regions = 'us' | 'other' | 'dachUk'

const region = ref<regions>('us')

const hsCalendarLinks = {
  other:
    'https://meetings.hubspot.com/dawid-waligora/sdr-calendar-dawid?embed=true',
  dachUk:
    'https://meetings.hubspot.com/julia-zebrowska/sdr-calendar-julia-?embed=true',
  us: 'https://meetings.hubspot.com/ronald-owen?embed=true',
}

const { t } = useI18n()
const { scrollToElement } = useScrollToElement()
const emit = defineEmits(['goToForm'])

watch(region, () => {
  scrollToElement('form-calendar-section')
})
</script>

<style lang="scss" scoped>
.calendars {
  position: relative;

  &__controls {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 400px;
  }

  &__section-title {
    text-align: left;
    font-weight: 600;
    display: block;
    font-size: var(--font-size-paragraph-s);
  }

  &__section-note {
    text-align: left;
  }

  &__section {
    margin-bottom: var(--space40);

    &:last-child {
      margin-bottom: 0;
    }
  }
  &__link-to-form {
    max-width: 400px;
    margin: 24px auto 0;
    text-align: left;
  }
  &__title {
    @include heading-3;
  }
}
</style>
